/**
 * Background/border style for server-generated form PDFs.
 *
 * true  = the server authors bare text fields (white fill, no border) and the viewer draws
 *         every text-field border itself: black by default, light blue for interactive
 *         fields, blue double-width for numbered-statement fields — the pre-flatten look.
 * false = the server authors the SMART convention (light-yellow fill on editable fields,
 *         authored borders) and the viewer draws no borders at all.
 *
 * Sent on every form request (suppressEditableFieldFill) and consulted by DefaultPDFViewer
 * to decide whether to paint hitbox borders — the two must stay in lockstep, or fields
 * render with double borders (both painted) or none (neither painted).
 */
export const SUPPRESS_EDITABLE_FIELD_FILL = true;
